import React from 'react';
import { Tag, Tooltip } from 'antd';
import {
  ExclamationCircleFilled,
  WarningOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { StatusType } from '@/pages/Shipments/statusType';
import { TruncateWithTooltip } from '@/components';
import { sentenceCase } from '@/common/helper';
import {
  buildStatusPillStyle,
  getCustomerLegStatusPillColors,
  getShipmentStatusPillColors,
  isCustomerLegTerminalStatus,
} from '@/pages/Shipments/statusTagColors';

interface StatusTagProps {
  type?: StatusType;
  status?: string;
  alert_status?: string[];
  customerLegEnabled?: boolean;
}

const HomeDrawerStatusTag: React.FC<StatusTagProps> = ({
  type = 4,
  status = '',
  alert_status = [],
  customerLegEnabled = false,
}) => {
  const filteredAlerts = (
    Array.isArray(alert_status) ? alert_status : []
  ).filter((s) => String(s).toLowerCase() !== String(status).toLowerCase());

  const customerLegColors = customerLegEnabled
    ? getCustomerLegStatusPillColors(status)
    : undefined;

  const renderIcon = (rawType: StatusType) => {
    const t = Number(rawType) as StatusType;
    const colors = customerLegColors ?? getShipmentStatusPillColors(t);
    const iconStyle = { color: colors.color, marginRight: 4, fontSize: 12 };

    if (customerLegColors) {
      return isCustomerLegTerminalStatus(status) &&
        String(status).trim().toUpperCase() === 'DELIVERED' ? (
        <CheckCircleOutlined style={iconStyle} />
      ) : null;
    }

    if (t === 0 || t === 4) {
      return <ExclamationCircleFilled style={iconStyle} />;
    }
    if (t === 1) {
      return <WarningOutlined style={iconStyle} />;
    }
    return null;
  };

  const t = Number(type) as StatusType;
  const colors = customerLegColors ?? getShipmentStatusPillColors(t);

  return (
    <Tag
      className='home-delay-tag'
      style={buildStatusPillStyle(colors, {
        borderRadius: 4,
        fontSize: 10,
        height: 20,
        fontWeight: 600,
        width: 'fit-content',
        display: 'inline-flex',
        alignItems: 'center',
      })}
    >
      {renderIcon(type)}

      <TruncateWithTooltip
        text={status ? sentenceCase(String(status)) : '--'}
        max={10}
        disableTooltip={false}
        render={(t) => <span>{sentenceCase(t)}</span>}
      />

      {filteredAlerts.length > 0 && (
        <Tooltip title={filteredAlerts.join(', ')}>
          <span style={{ marginLeft: 3, color: 'inherit', cursor: 'pointer' }}>
            +{filteredAlerts.length}
          </span>
        </Tooltip>
      )}
    </Tag>
  );
};

export default HomeDrawerStatusTag;
